<script setup>
/*
    Shape widget

    Components:
        primary: <v-sheet>

    Widget Properties:
        value: []

    Component Args

    CSS properties:
        border-style: none, hidden, dotted, dashed, solid, double, groove, ridge, inset, outset
        border-width
        border-color
        transform: rotate(45deg) # rotation
        transform-origin: 'top left' # rotation origin
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); # drop shadow
        background: color # inner color
    
    Examples:
        class: 'circle' // square
 */
import {reactive, ref} from 'vue'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'

defineExpose({update})

const props = defineProps({
    loading: Boolean,
    widget: Object,
})

const page = reactive({
    args: {},
    data: {},
})

const primary = ref(null)

const DefaultStyles = {
    card: {
        background: 'transparent',
    },
    primary: {
        'border-color': 'black',
        'border-width': '2px',
        'border-style': 'solid',
        'background': 'transparent',
    },
}

function update() {
    Object.assign(page, getWidgetProps(props.widget, {primary}, {styles: DefaultStyles})) 
}
</script>

<template>
    <v-sheet ref="primary" class="shape-widget" v-bind="page.args" />
</template>

<style lang="scss" scoped>
.shape-widget {
    container-type: size;
    position: relative;
    height: 100cqh !important;
    width: 100cqw !important;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}
.square {
    height: min(100cqh, 100cqw) !important;
    width: min(100cqh, 100cqw) !important;
}
.circle {
    border-radius: 50%;
    height: min(100cqh, 100cqw) !important;
    width: min(100cqh, 100cqw) !important;
}
</style>
